import PendingActionWindowModal from './PendingActionWindowModal'

export default PendingActionWindowModal
